import service = require("./breeze.entityManager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service("CompetenceTypeCVMappingCompetenceGroupService", CompetenceTypeCVMappingCompetenceGroupService);

    CompetenceTypeCVMappingCompetenceGroupService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

class CompetenceTypeCVMappingCompetenceGroupService extends base.BaseDataService<Nema.Crew.Model.CompetenceTypeCVMappingCompetenceGroup> implements ICompetenceTypeCVMappingCompetenceGroupService {

    constructor(entityManagerService: service.EntityManagerService, breeze, $log, $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    protected get EntityName(): string {
        return "CompetenceTypeCVMappingCompetenceGroup";
    }

    protected get EntitiesName(): string {
        return "CompetenceTypeCVMappingCompetenceGroups";
    }

    /**
     * Override the getAll, since CompetenceRequirementCollection do not 
     * have the Active and SortTag properties.
     */
    public getByCompetenceTypeMappingId(competenceTypeMappingId: number, _active: boolean = true) {

        var self = this;

        var entityQuery = self.createEntityQuery()
            .where("CompetenceTypeCVMappingId", "==", competenceTypeMappingId)
            .using(this.entityManager);

        var promise = entityQuery.execute()
        // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => {
            self.entityCollection = entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).executeLocally();
            return self.entityCollection;
        });

        return promise;
    }
}

export interface ICompetenceTypeCVMappingCompetenceGroupService extends base.IDataService<Nema.Crew.Model.CompetenceTypeCVMappingCompetenceGroup> {
    getByCompetenceTypeMappingId(competenceTypeMappingId: number, active?: boolean);
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/CompetenceTypeCVMappingCompetenceGroup.dataservice.ts